import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom"; // Link is used for navigation
import "./Navbar.css";
import logo from "./Verdure Brand Logo .png";

function Navbar() {
  const [isAuth, setIsAuth] = useState(false);

  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem("access_token");
      // console.log('Token from localStorage:', token);
      setIsAuth(!!token);
    };

    checkAuth(); // Initial check when component mounts

    window.addEventListener("storage", checkAuth);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("storage", checkAuth);
    };
  }, []);

  return (
    <section class="navheader">
      <a href="/shop">
        <img src={logo} className="logo"></img>
      </a>
      <div class="navigationOptions">
        <ul class="navvv" style={{ listStyleType: "none" }}>
          <li>
            <Link to="/">Home</Link> {/* Link to Home */}
          </li>
          <li id="shopNavLink">
            <Link to="/shop" id="shopNavLink">
              Shop
            </Link>{" "}
            {/* Link to Shop Page */}
          </li>
          <li>
            <Link to="/cart">Cart</Link> {/* Link to Cart Page */}
          </li>
          <li>
            {isAuth ? (
              <Link to="/account">Account</Link>
            ) : (
              <Link to="/login">Login</Link>
            )}
          </li>
        </ul>
      </div>
    </section>
  );
}

export default Navbar;
